
import { useEffect, useState } from "react";

interface HelpOverlayProps {
  showHelp: boolean;
}

export function HelpOverlay({ showHelp }: HelpOverlayProps) {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    if (showHelp) {
      setIsVisible(true);
    } else {
      // Start fade out
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 300); // Match the CSS animation duration
      return () => clearTimeout(timer);
    }
  }, [showHelp]);
  
  if (!showHelp && !isVisible) return null;
  
  return (
    <div className={`absolute right-4 sm:right-8 top-[calc(50%+15px)] transform -translate-y-1/2 ${showHelp ? "animate-fade-in" : "animate-fade-out"}`}>
      <img 
        src="/lovable-uploads/be8fad0e-3332-487a-a207-921f4a620760.png" 
        alt="Game instructions" 
        className="max-w-[80px] sm:max-w-[100px] opacity-90"
      />
    </div>
  );
}
